import { combineReducers } from "redux";
import sessionStorage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import consoleReducer from "../modules/console/redux/console.reducer";
import loginReducer from "../modules/login/redux/loginReducer";
import welcomeReducer from "../modules/welcome/redux/welcome.reducer";
import landingPageReducer from "../modules/landing-page/redux/landing-page.reducer";
import productSelectionReducer from "../modules/product-selection/redux/product-selection.reducer";
import portalReducer from "../modules/portal/redux/portal.reducer";
import consentReducer from "../modules/consent/redux/consentReducer";
import dynamicFormReducer from "../modules/dynamic-form/redux/dynamic-form.reducer";

const rootReducer = combineReducers({
  consoleReducer: persistReducer({ key: "console", storage: sessionStorage }, consoleReducer.reducer),
  loginReducer: persistReducer({ key: "login", storage: sessionStorage }, loginReducer.reducer),
  welcomeReducer: persistReducer({ key: "welcome", storage: sessionStorage }, welcomeReducer.reducer),
  landingPageReducer: persistReducer({ key: "landing-page", storage: sessionStorage }, landingPageReducer.reducer),
  portalReducer: persistReducer({ key: "portal", storage: sessionStorage }, portalReducer.reducer),
  consentReducer: persistReducer({ key: "consent", storage: sessionStorage }, consentReducer.reducer),
  productSelectionReducer: persistReducer(
    {
      key: "product-selection",
      storage: sessionStorage,
    },
    productSelectionReducer.reducer,
  ),
  dynamicFormReducer: persistReducer({ key: "dynamic-form", storage: sessionStorage }, dynamicFormReducer.reducer),
});

export default rootReducer;
